<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    scrollable
    @input="cancel('shopeeSyncOrder')">
    <template v-slot:activator="{}">
      <toggle-form
        v-model="form.shopeeSyncOrder"
        :state="state['shopeeSyncOrder']"
        :text="$t('connector.shopee.field.order.label')"
        @change="confirm('shopeeSyncOrder')" />
    </template>
    <v-card
      class="app-card"
      tile>
      <v-card-title>
        <div class="d-flex text-subtitle-1">
          <v-icon
            color="yellow darken-2"
            class="mr-4 icon-circle-yellow">
            mdi-exclamation
          </v-icon>
          <span class="yellow--text text--darken-2">
            {{ $t('connector.shopee.field.order.dialog.title') }}
          </span>
        </div>
        <v-spacer />
        <v-btn
          icon
          small
          @click="cancel('shopeeSyncOrder')">
          <v-icon small>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="mx-12">
          <div class="secondary--text subtitle-1 dialog-text">
            {{ $t('connector.shopee.field.order.dialog.description') }}
          </div>
          <v-divider
            v-if="readMore"
            class="my-3" />
          <div v-if="readMore">
            <title-label
              :label="$t('connector.shopee.btn.learn')"
              class="mb-3" />
            <div class="mb-3 grey--text text-subtitle-1 dialog-text">
              {{ $t('connector.shopee.field.order.dialog.note') }}
            </div>
            <v-btn
              :href="`${shipnityUrl}/products`"
              target="_blank"
              color="primary"
              dense
              outlined>
              {{ $t('connector.shopee.btn.product') }}
            </v-btn>
          </div>
          <a
            v-else
            class="primary--text mt-4 d-block subtitle-1"
            text
            @click="expandReadMore(true)">
            {{ $t('connector.shopee.btn.learn') }}...
          </a>
        </div>
      </v-card-text>
      <v-card-actions class="connector_dialog--action">
        <v-spacer />
        <v-btn
          color="blue darken-1"
          text
          @click="cancel('shopeeSyncOrder')">
          {{ $t('connector.shopee.btn.close') }}
        </v-btn>
        <v-btn
          color="primary"
          depressed
          rounded
          @click="submit('shopeeSyncOrder')">
          {{ $t('connector.shopee.btn.connectOrder') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { GET_SETTING_SHOPEE, UPDATE_SETTING } from '@/resources/graphql'

export default {
  apollo: {
    setting: () => ({
      fetchPolicy: 'no-cache',
      query: GET_SETTING_SHOPEE,
      result ({ data: { setting } }) {
        this.form.shopeeSyncOrder = setting.shopeeSyncOrder
      }
    })
  },
  data () {
    return {
      shipnityUrl: process.env.VUE_APP_SHIPNITY,
      dialog: false,
      readMore: false,
      state: {
        shopeeSyncOrder: 'ready'
      },
      form: {
        shopeeSyncOrder: false
      }
    }
  },
  methods: {
    expandReadMore (value) {
      this.readMore = value
    },
    confirm (field) {
      this.dialog = this.form[field]
      if (!this.dialog) {
        this.submit(field)
      }
    },
    cancel (field) {
      this.form[field] = false
      this.dialog = false
    },
    async submit (field) {
      this.dialog = false
      this.state[field] = 'loading'
      const res = await this.$apollo.mutate({
        mutation: UPDATE_SETTING,
        variables: {
          input: {
            [field]: this.form[field]
          }
        }
      }).catch(() => {
        this.state[field] = 'error'
      })
      if (res) {
        const { data: { updateSetting } } = res
        if (updateSetting.errors && Object.keys(updateSetting.errors).length) {
          this.state[field] = 'error'
        } else {
          this.state[field] = 'success'
        }
      }
    }
  }
}
</script>

<style>

</style>

<style scoped>
  .icon-circle-yellow {
    border: 3px solid #fbc02d;
    border-radius: 50px
  }
  .dialog-text {
    line-height: 1.5rem !important;
    letter-spacing: .0178571429em !important;
  }
</style>
